<template>
  <el-row>
    <el-col>
      <el-cascader class="inputWidth" v-model="selectCity" expandTrigger="hover" :props="chinaData"></el-cascader>
    </el-col>
  </el-row>
</template>
<script>
import { getAction } from "@/comm/manage";
export default {
  props: {},
  mounted() {},
  methods: {},
  data() {
    // let id = 0;
    return {
      chinaData: {
        lazy: true,
        lazyLoad(node, resolve) {
          var params = {
            pageSize: 1000,
          };
          if (node.root) {
            params.deep = 1;
          } else {
            params.pid = node.data.value;
          }

          getAction("/chinadata/tsChinaDataLeave/list", params).then((res) => {
            if (res.success) {
              const nodes = res.result.records.map((item) => ({
                value: item.cid,
                label: item.name,
                leaf: item.cid.length > 6,
              }));
              resolve(nodes);
            }
            if (res.code === 510) {
              this.$message.warning(res.message);
            }
          });

          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        },
      },
    };
  },
};
</script>
<style scoped lang="stylus"></style>